import React, { Component } from 'react';
import TeamEfficiency from './TeamEfficiency';
import { SEARCH_OPTIONS_SCHEMA } from '../../../utils/Analytics';
import AirlineType from '../../../models/AirlineType';
import moment, { Moment } from 'moment';
import { connect } from 'react-redux';
import ResponseError from '../../../models/ResponseError';
import { receiveError } from '../../../store/actions/notificationAction';
import analyticsRemote from '../../../api/analyticsRemote';
import ApiResponse from '../../../models/ApiResponse';
import { Teams, TeamEfficiencyData, filterOptions, CustomerWaitSearchOption } from '../../../models/Analytics';
import { ExportToCsv } from 'export-to-csv';

interface TeamEfficiencyContainerProps {
  receiveError: Function;
  airlines: AirlineType[];
  startDate: Moment;
  endDate: Moment;
  handleChangeDate: (dateType: string, event: any) => void;
};

interface TeamEfficiencyContainerState {
  filterOptions: filterOptions;
  progress: boolean;
  searchOptions: CustomerWaitSearchOption;
  airlines: AirlineType[];
  data: TeamEfficiencyData[];
  orders: TeamEfficiencyData[];
  team: Teams[];
  cTeam: Teams[];
  counter: Teams[];
  warehouse: Teams[];
  cSort: string;
  wSort: string;
  exceedHours: number;
};

class TeamEfficiencyContainer extends Component<TeamEfficiencyContainerProps, TeamEfficiencyContainerState> {
  state = {
    filterOptions: {
      process: true,
      carriers: true,
      time: true,
      export: true,
    },
    progress: false,
    searchOptions: { ...SEARCH_OPTIONS_SCHEMA, startDate: this.props.startDate, endDate: this.props.endDate },
    airlines: this.props.airlines,
    data: [],
    orders: [],
    team: [],
    cTeam: [],
    counter: [],
    warehouse: [],
    cSort: 'awbs',
    wSort: 'awbs',
    exceedHours: 0
  }

  componentWillReceiveProps(nextProps: TeamEfficiencyContainerProps) {
    let searchOptions = this.state.searchOptions;
    if (nextProps.startDate !== this.state.searchOptions.startDate || nextProps.endDate !== this.state.searchOptions.endDate) {
      searchOptions.startDate = nextProps.startDate;
      searchOptions.endDate = nextProps.endDate;
      this.setState({ searchOptions }, () => {
        this.loadOdersData();
      });
    }
    if (nextProps.airlines != this.state.airlines) {
      let carr = nextProps.airlines.map(a => a.iata_code);
      this.setState({ airlines: nextProps.airlines, searchOptions: { ...this.state.searchOptions, carr: carr.toString() } }, () => {
        this.filterOdersData();
      });
    }
  }

  componentDidMount() {
    if (this.state.airlines.length > 0) {
      let carr = this.state.airlines.map((a: AirlineType) => a.iata_code);
      this.setState({ searchOptions: { ...this.state.searchOptions, carr: carr.toString() } }, () => {
        this.filterOdersData();
      });
    }
    this.loadOdersData();
  }

  handleExceedHoursChange = (value: any): void => {
    // Convert empty string or null to undefined
    const parsedValue = value === '' || value === null ? undefined : value;
    
    this.setState({ exceedHours: parsedValue }, () => {
      this.loadOdersData();
    });
  }

  loadOdersData = (): void => {
    this.setState({ progress: true }, () => {
      let searchOptions = this.state.searchOptions;
      let startDate: string = searchOptions.startDate.format('YYYYMMDD');
      let endDate: string = searchOptions.endDate.format('YYYYMMDD');
      let pickUp: boolean = searchOptions.pickUp;
      let dropOff: boolean = searchOptions.dropOff;
      analyticsRemote.getTeamEfficiency(
        startDate,
        endDate,
        pickUp,
        dropOff,
        this.state.exceedHours
      ).then((resp: ApiResponse<Array<TeamEfficiencyData>>) => {
        const data: Array<TeamEfficiencyData> | undefined = resp.result;
        const error: ResponseError | undefined = resp.error;
        if (data) {
          this.setState({ data }, () => {
            this.filterOdersData();
          });
        }
        if (error) {
          this.props.receiveError(error);
        };
        this.setState({ progress: false });
      });
    });
  
  }


  filterOdersData = (): void => {
    let orders = this.state.airlines.length > 0 && this.state.searchOptions.carr != '' ? [...this.state.data] : [];
    // Handled Carriers
    if (this.state.searchOptions.carr && this.state.searchOptions.carr != '') {
      orders = orders.filter((o: TeamEfficiencyData) => {
        let found = false;
        let items: TeamEfficiencyData['items'] = [];
        o.items.map((i) => {
          if (i.awb && i.awb.airline_code) {
            if (i.awb.airline_code && this.state.searchOptions.carr.includes(i.awb.airline_code)) {
              found = true;
              items.push(i);
            }
          }
        });
        if (found) {
          return { ...o, items };
        }
      });
    }
    // Time
    if (this.state.searchOptions.startTime && this.state.searchOptions.endTime) {
      orders = orders.filter((o: TeamEfficiencyData) => {
        let time = moment(o.pickup_time || '0001', 'HHmm');
        if (time.isAfter(this.state.searchOptions.startTime) && time.isBefore(this.state.searchOptions.endTime)) {
          return o;
        }
      });
    }
    this.setState({ orders }, () => {
      this.getDataWh();
      this.getDataCounter();
    });
  }

  getDataWh = (): void => {
    let team: Teams[] = [];
    this.state.orders.map((o: TeamEfficiencyData) => {
      if (o && o.gha) {
        const exists = team.some(t => t.id === o.gha.id);
        if (!exists) {
          team.push({ id: o.gha.id, name: o.gha.first_name + ' ' + o.gha.last_name, wgt: 0, pcs: 0, awbs: 0, orders: 0, doc: 0, payment: 0, screen: 0, dim: 0, waitlist: 0, pick: 0, drop: 0 });
        }
        const index = team.findIndex(t => t.id === o.gha.id);
        if (index >= 0) {
          o.items.map((i) => {
            team[index].wgt += i.weight;
            team[index].pcs += i.pieces;
            team[index].awbs++;
            team[index].pick += o.order_type == 'po' ? 1 : 0;
            team[index].drop += o.order_type == 'do' ? 1 : 0;
            team[index].payment += o.order_type == 'po' ? i.payment ? 0 : 1 : 0;
            team[index].doc += i.doc ? 1 : 0;
            team[index].dim += i.dim ? 1 : 0;
            team[index].screen += i.screen ? 1 : 0;
          });
          team[index].waitlist += o.driver ? 1 : 0;
          team[index].orders++;
        }
      }
    });
    team = team.map((t: Teams) => {
      return {
        ...t,
        wgt: Math.round(t.wgt),
        payment: Math.round((t.payment / t.pick) * 100),
        doc: Math.round((t.doc / t.awbs) * 100),
        waitlist: Math.round((t.waitlist / t.orders) * 100),
        screen: Math.round((t.screen / t.drop) * 100),
        dim: Math.round((t.dim / t.drop) * 100)
      };
    });
    this.setState({ team: team }, () => {
      this.sortData();
    });
  }

  getDataCounter = (): void => {
    let cteam: Teams[] = [];
    this.state.orders.map((o: TeamEfficiencyData) => {
      if (o && o.gha) {
        const exists = cteam.some(t => t.id === o.forwarder.id);
        if (!exists) {
          cteam.push({ id: o.forwarder.id, name: o.forwarder.first_name + ' ' + o.forwarder.last_name, wgt: 0, pcs: 0, awbs: 0, orders: 0, doc: 0, payment: 0, screen: 0, dim: 0, waitlist: 0, pick: 0, drop: 0 });
        }
        const index = cteam.findIndex(t => t.id === o.forwarder.id);
        if (index >= 0) {
          o.items.map((i) => {
            cteam[index].wgt += i.weight;
            cteam[index].pcs += i.pieces;
            cteam[index].awbs++;
            cteam[index].pick += o.order_type == 'po' ? 1 : 0;
            cteam[index].drop += o.order_type == 'do' ? 1 : 0;
            cteam[index].payment += o.order_type == 'po' ? i.payment ? 0 : 1 : 0;
            cteam[index].doc += i.doc ? 1 : 0;
            cteam[index].dim += i.dim ? 1 : 0;
            cteam[index].screen += i.screen ? 1 : 0;
          });
          cteam[index].waitlist += o.driver ? 1 : 0;
          cteam[index].orders++;
        }
      }
    });
    cteam = cteam.map((t: Teams) => {
      return {
        ...t,
        wgt: Math.round(t.wgt),
        payment: Math.round((t.payment / t.pick) * 100),
        doc: Math.round((t.doc / t.awbs) * 100),
        waitlist: Math.round((t.waitlist / t.orders) * 100),
        screen: Math.round((t.screen / t.drop) * 100),
        dim: Math.round((t.dim / t.drop) * 100)
      };
    });
    this.setState({ cTeam: cteam }, () => {
      this.sortData();
    });
  }

  sortData = (): void => {
    let counter = [...this.state.cTeam];
    let warehouse = [...this.state.team];
    counter = counter.sort((a: any, b: any) => {
      return parseFloat(b[this.state.cSort]) - parseFloat(a[this.state.cSort]);
    });
    warehouse = warehouse.sort((a: any, b: any) => {
      return parseFloat(b[this.state.wSort]) - parseFloat(a[this.state.wSort]);
    });
    this.setState({ counter, warehouse });

  }

  handleChangeOption = (type: string, event: any): void => {
    this.setState({ ...this.state, [type]: event }, () => {
      this.sortData();
    });
  }

  handleExport = (type: string): void => {
    let headers: string[] = [];
    let data: object[] = [];
    let cdata: object[] = [];
    let wdata: object[] = [];
    let filename = '';
    if (type == 'all') {
      headers = ['User', 'Awbs', 'Orders', 'Weight', 'Pcs', 'Payment Accuracy', 'Waitlist Usage', 'Docs Attachment', 'Dimming Ratio', 'Screening Ratio'];
      filename = 'Team Efficiency';
      cdata = this.state.counter.map((t: Teams) => {
        return {
          name: t.name,
          awbs: t.awbs,
          orders: t.orders,
          wgt: t.wgt,
          pcs: t.pcs,
          pay: t.payment,
          wait: t.waitlist,
          doc: t.doc,
          dim: 'NA',
          scn: 'NA'
        };
      });
      wdata = this.state.warehouse.map((t: Teams) => {
        return {
          name: t.name,
          awbs: t.awbs,
          orders: t.orders,
          wgt: t.wgt,
          pcs: t.pcs,
          pay: 'NA',
          wait: 'NA',
          doc: 'NA',
          dim: t.dim,
          scn: t.screen,
        };
      });
      data = [...(cdata || []), ...(wdata || [])];
    }
    if (type == 'counter') {
      headers = ['User', 'Awbs', 'Orders', 'Weight', 'Pcs', 'Payment Accuracy', 'Waitlist Usage', 'Docs Attachment'];
      filename = 'Counter Efficiency';
      data = this.state.counter.map((t: Teams) => {
        return {
          name: t.name,
          awbs: t.awbs,
          orders: t.orders,
          wgt: t.wgt,
          pcs: t.pcs,
          pay: t.payment,
          wait: t.waitlist,
          doc: t.doc
        };
      });
    }
    if (type == 'warehouse') {
      headers = ['User', 'Awbs', 'Orders', 'Weight', 'Pcs', 'Dimming Ratio', 'Screening Ratio'];
      filename = 'Warehouse Efficiency';
      data = this.state.warehouse.map((t: Teams) => {
        return {
          name: t.name,
          awbs: t.awbs,
          orders: t.orders,
          wgt: t.wgt,
          pcs: t.pcs,
          dim: t.dim,
          scn: t.screen
        };
      });
    }
    let options = {
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalSeparator: '.',
      showLabels: true,
      showTitle: false,
      filename: filename,
      useTextFile: false,
      useBom: false,
      useKeysAsHeaders: false,
      headers: headers
    };
    const csvExporter = new ExportToCsv(options);
    csvExporter.generateCsv(data);
  }

  handleChangeCarriers = (type: string, value: boolean): void => {
    const searchOptions = { ...this.state.searchOptions };
    let carr = searchOptions.carr.split(',');
    if (type == 'GLOABL' && !value) {
      carr = [];
      searchOptions.carrCheck = value;
    } else if (type == 'GLOABL' && value) {
      carr = this.state.airlines.map((a: AirlineType) => a.iata_code);
      searchOptions.carrCheck = value;
    } else {
      if (value) {
        carr.push(type);
      } else {
        var index = carr.indexOf(type);
        if (index !== -1) {
          carr.splice(index, 1);
        }
      }
    }
    searchOptions.carr = carr.toString();
    this.setState({ searchOptions: searchOptions }, () => {
      this.filterOdersData();
    });
  }
  handleChangeProcess = (type: string, value: boolean): void => {
    let searchOptions = { ...this.state.searchOptions, [type]: value };
    this.setState({ searchOptions: searchOptions }, () => {
      this.loadOdersData();
    });
  }

  handleChangeTime = (type: string, date: Moment): void => {
    let searchOptions = { ...this.state.searchOptions, [type]: date }
    this.setState({ searchOptions: searchOptions }, () => {
      this.filterOdersData();
    });
  }

  render() {
    return (
      <TeamEfficiency
        startDate={this.state.searchOptions.startDate}
        endDate={this.state.searchOptions.endDate}
        progress={this.state.progress}
        pickUp={this.state.searchOptions.pickUp}
        dropOff={this.state.searchOptions.dropOff}
        startTime={this.state.searchOptions.startTime}
        endTime={this.state.searchOptions.endTime}
        carrCheck={this.state.searchOptions.carrCheck}
        carr={this.state.searchOptions.carr}
        filterOptions={this.state.filterOptions}
        airlines={this.state.airlines}
        counter={this.state.counter}
        cSort={this.state.cSort}
        warehouse={this.state.warehouse}
        wSort={this.state.wSort}
        handleChangeDate={this.props.handleChangeDate}
        handleChangeProcess={this.handleChangeProcess}
        handleChangeCarriers={this.handleChangeCarriers}
        handleChangeTime={this.handleChangeTime}
        handleChangeOption={this.handleChangeOption}
        handleExport={this.handleExport}
        handleExceedHoursChange={this.handleExceedHoursChange}
        exceedHours={this.state.exceedHours} 
      />
    )
  };
}

const mapStateToProps = (state: any) => {
  return {};
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    receiveError: (error: ResponseError) => dispatch(receiveError(error))
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(TeamEfficiencyContainer);